import ItemBuilderView, { ItemBuilderViewType } from './ItemBuilderView';
import ItemViewArgs from '../ItemViewArgs';
import Modal from '../Modal';
import ItemView from '../ItemView';
import { Item } from '../Item';
import Position from '../../../rule/workflow/support/Position';
import $ from 'jquery';

abstract class AbstractItemView implements ItemView {
  protected readonly builderView: ItemBuilderView;
  protected readonly model: Modal;
  protected el: string;
  protected parentEl: string;
  protected type: ItemBuilderViewType;

  protected constructor(args: ItemViewArgs<Modal>) {
    this.builderView = args.view;
    this.model = args.model;
    this.el = args.el;
    this.parentEl = args.parentEl;
    this.type = args.type;
  }

  public exchange(view: ItemView): void {}

  public getBoundingClientRect(): DOMRect {
    return $(this.el).get()[0].getBoundingClientRect();
  }

  public getBuilderView(): ItemBuilderView {
    return this.builderView;
  }

  public getModel<T extends Item>(): Modal<T> {
    return this.model as Modal<T>;
  }

  public initialize() {}

  public terminate() {}

  public getNode(): string {
    return this.el;
  }

  public getParentNode(): string {
    return this.parentEl;
  }

  public renderPosition(position: Position): void {
    $(this.el)
      .css('left', position.x + 'px')
      .css('top', position.y + 'px');
  }

  protected abstract getItemPrefix(): string;
}

export default AbstractItemView;
